var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewPath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 72,
    viewBox: "0 0 109 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_30_1436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 109,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.918 23.3792L11.6896 0L-1.32322e-05 48.6143L97.2287 71.9935L108.918 23.3792Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_30_1436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4768 29.7538C36.3897 19.181 64.0827 20.5689 76.1463 40.44",
    stroke: "#23201F",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9816 51.0114C82.3419 47.2031 82.6117 43.9295 82.7069 40.223C83.3507 36.4633 81.3086 29.8486 85.3362 27.9156C87.6581 27.1132 89.6182 29.1201 89.7499 30.8097C90.0274 39.3863 89.5971 48.0282 87.9083 56.4631C87.4941 58.9039 84.4527 59.5889 82.6224 58.723C79.1326 57.0723 63.5452 49.4776 59.2688 47.3087C57.2053 46.4289 57.742 42.8667 60.1938 42.8031C68.1891 42.9196 74.5424 48.5263 81.9816 51.0114Z",
    fill: "#23201F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewPath);
export default __webpack_public_path__ + "static/media/review-path.99e8293f863295a8af29000c20d002b7.svg";
export { ForwardRef as ReactComponent };